import PageTitle from '../PageTitle/PageTitle'

const About = () => {
    return(
        <div>
            <PageTitle>About</PageTitle>
            <p>Simply List App <br/> creat new lists add cards, make your life easier! 😊</p>
        </div>
    )
}

export default About